import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.635 1.635a5.58 5.58 0 0 1 7.892 0l11.68 11.68V5.581a5.581 5.581 0 0 1 11.163 0v21.208a5.581 5.581 0 0 1-9.527 3.946L1.635 9.527a5.58 5.58 0 0 1 0-7.892M.327 12.605a1.116 1.116 0 0 1 1.578 0l6.698 6.697a1.116 1.116 0 0 1-1.579 1.579L.327 14.184a1.116 1.116 0 0 1 0-1.579m9.488 9.488a1.116 1.116 0 0 1 1.578 0l.558.558a1.116 1.116 0 1 1-1.578 1.579l-.558-.558a1.116 1.116 0 0 1 0-1.579M.327 18.186a1.116 1.116 0 0 1 1.578 0l10.046 10.046a1.116 1.116 0 0 1-1.578 1.579L.327 19.765a1.116 1.116 0 0 1 0-1.579m0 5.581a1.116 1.116 0 0 1 1.578 0l1.117 1.117a1.116 1.116 0 1 1-1.579 1.578L.327 25.346a1.116 1.116 0 0 1 0-1.579m3.349 3.349a1.116 1.116 0 0 1 1.578 0l3.907 3.907A1.116 1.116 0 0 1 7.582 32.6l-3.906-3.907a1.116 1.116 0 0 1 0-1.578M.327 29.348a1.116 1.116 0 0 1 1.578 0l1.675 1.675A1.116 1.116 0 0 1 2 32.6L.327 30.927a1.116 1.116 0 0 1 0-1.579"
	})]
});
const ForwardRef = forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
